
import Tile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";
import config from "./../config"

let layersMap = { layers: [] };

var contextPath = config.getContextPath();


var districtFilterIDs = config.getCustomMapOptions().districtids.map(function (districtID) {
	return "'" + districtID + "'"
}).join()



var commercialspaceLayer = new Tile({
	baseLayer: false,
	name: "commzone",
	displayInLayerSwitcher: false,
	source: new TileWMS({
		url: contextPath + '/ows/wms',
		params: {
			SRS: "EPSG:3857",
			LAYERS: "commzone_map_public",
			TILED: "TRUE",
			TRANSPARENT: "TRUE",
			CQL_FILTER: "districtid IN (" + districtFilterIDs
				+ ");"
		},
		serverType: 'geoserver',
		transition: 0
	})
})
var parcelLayer = new Tile({
	baseLayer: false,
	name: "parcel",
	maxResolution: 100,
	displayInLayerSwitcher: false,
	source: new TileWMS({
		url: contextPath + '/ows/wms',
		params: {
			SRS: "EPSG:3857",
			LAYERS: "parcel_map_public",
			TILED: "TRUE",
			TRANSPARENT: "TRUE",
			CQL_FILTER: "districtid IN (" + districtFilterIDs
				+ ");"
		},
		serverType: 'geoserver',
		transition: 0
	})
})
layersMap["commercialspaceLayer"] = commercialspaceLayer;
layersMap["layers"].push(commercialspaceLayer);
layersMap["parcelLayer"] = parcelLayer;
layersMap["layers"].push(parcelLayer);


export default layersMap